import { t } from 'ttag';
import {
  FLIP_BACK,
  FLIP_CARD,
  FLIP_FRONT,
  FlipBackDefinition,
  FlipCardDefinition,
  IMAGE,
  ImageDefinition,
  LAYOUT_LIST,
  LayoutListDefinition,
  PERSONALIZED_CARD,
  TEXT,
  TextDefinition
} from '../items';
import { Translator } from '../Translator';
import { TextHelper } from './itemHelpers/TextHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { useEditorStore } from '~/shell/Store';
import { OPTIONAL_TEXT_FIELDS } from '../utils/optionalFields';

export const Cards1: Translator = sequence => {
  const cardsList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.cardlist`,
    values: {
      orientation: 'row',
      align: 'center',
      wrap: true,
      padded: true
    },
    items: []
  } as LayoutListDefinition;

  const mainList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.list`,
    values: {
      align: 'center',
      padded: true
    },
    items: []
  } as LayoutListDefinition;

  // let i = 0;

  function showLogo() {
    // i++;
    // return i % 2 === 0;
    return true;
  }

  const root = translate(sequence, item => {
    if (item.__typename === 'Card') {
      cardsList.items.push({
        id: item.id,
        type: FLIP_CARD,
        values: {
          width: '270px',
          height: '380px',
          type: 'div',
          separateTitleAndBody: true,
          cardTitle: item.title
        },
        items: [
          {
            id: `${item.id}.back`,
            type: FLIP_BACK,
            items: [
              sequence.personalization
                ? {
                    id: `${item.id}.backImg`,
                    type: PERSONALIZED_CARD,
                    values: {
                      showLogo: showLogo()
                    }
                  }
                : !item.subtitle
                  ? ({
                      id: `${item.id}.backImg`,
                      type: IMAGE,
                      values: {
                        imageGenerationPlacement: 'card_image',
                        url: item.pictures?.[0]?.mediaUrl,
                        alt: item.pictures?.[0]?.name,
                        editable: false
                      }
                    } as ImageDefinition)
                  : ({
                      id: `${item.id}.front-list`,
                      type: LAYOUT_LIST,
                      values: {
                        padded: true
                      },
                      items: [
                        {
                          id: `${item.id}.front-heading`,
                          type: TEXT,
                          values: {
                            variant: 'heading2',
                            editable: false
                          }
                        } as TextDefinition,
                        {
                          id: `${item.id}_title`,
                          type: TEXT,
                          values: {
                            value: item.title,
                            editable: false
                          }
                        } as TextDefinition
                      ]
                    } as LayoutListDefinition)
            ]
          } as FlipBackDefinition,
          {
            id: `${item.id}.front`,
            type: FLIP_FRONT,
            items: [
              item.pictures?.[1]
                ? ({
                    id: `${item.id}.backImg`,
                    type: IMAGE,
                    values: {
                      imageGenerationPlacement: 'card_image',
                      url: item.pictures?.[1]?.mediaUrl,
                      alt: item.pictures?.[1]?.name
                    }
                  } as ImageDefinition)
                : item.subtitle && item.pictures && item.pictures[0]
                  ? ({
                      id: `${item.id}.backImg`,
                      type: IMAGE,
                      values: {
                        imageGenerationPlacement: 'card_image',
                        url: item.pictures?.[0]?.mediaUrl,
                        alt: item.pictures?.[0]?.name,
                        editable: false
                      }
                    } as ImageDefinition)
                  : ({
                      id: `${item.id}.front-list`,
                      type: LAYOUT_LIST,
                      values: {
                        padded: true
                      },
                      items: [
                        {
                          id: `${item.id}_title`,
                          type: TEXT,
                          values: {
                            variant: 'titleForCard',
                            value: item.title,
                            editable: false
                          }
                        } as TextDefinition,
                        {
                          id: `${item.id}_body`,
                          type: TEXT,
                          values: {
                            value: item.body,
                            canScroll: true,
                            maxHeight: '300px',
                            editable: false
                          }
                        } as TextDefinition
                      ]
                    } as LayoutListDefinition)
            ]
          }
        ]
      } as FlipCardDefinition);
    } else if (item.__typename === 'Text') {
      const textItem = item as ItemOfType<'Text'>;
      const sectionLabel =
        [textItem.subtitle, textItem.title].filter(Boolean).join(', ') ||
        undefined;
      mainList.items = [
        {
          type: LAYOUT_LIST,
          id: `${sequence.id}.list`,
          values: {
            orientation: 'column',
            align: 'bottom',
            padding: '50px 0px 0px 0px',
            ...(sectionLabel && { ariaLabel: sectionLabel })
          },
          items: TextHelper(textItem as ItemOfType<'Text'>, {
            optional: OPTIONAL_TEXT_FIELDS
          })
        } as LayoutListDefinition
      ];
    }

    return null;
  });

  mainList.items.push(cardsList);

  try {
    const { contentEditable } = useEditorStore.getState();
    if (contentEditable) {
      const existingCardCount = cardsList.items.filter(
        i => i.type === FLIP_CARD
      ).length;
      cardsList.items.push({
        id: `${sequence.id}.add-card-placeholder-${existingCardCount + 1}`,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        type: 'AddCardPlaceholder' as any,
        values: {
          width: '270px',
          height: '380px',
          text: t`Add a card`,
          separateTitleAndBody: true
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any);
    }
  } catch (e) {
    // silently ignore if store unavailable in this render context
  }

  if (mainList.items.length > 1) {
    // adding a dummy item for spacing... bit hackish but ok
    mainList.items.push({
      type: LAYOUT_LIST,
      id: `${sequence.id}.blank`
    } as LayoutListDefinition);
  }
  root.items.push(mainList);

  return root;
};
